// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message. 
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
/**
 * 
 * @export
 * @interface CustomerAccountInfomation
 */
export interface CustomerAccountInfomation {
    /**
     * 
     * @type {string}
     * @memberof CustomerAccountInfomation
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerAccountInfomation
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerAccountInfomation
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerAccountInfomation
     */
    company?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerAccountInfomation
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerAccountInfomation
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerAccountInfomation
     */
    addressLine1?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerAccountInfomation
     */
    addressLine2?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerAccountInfomation
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerAccountInfomation
     */
    region?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerAccountInfomation
     */
    postalCode?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerAccountInfomation
     */
    language?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerAccountInfomation
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerAccountInfomation
     */
    url?: string;
}

export function CustomerAccountInfomationFromJSON(json: any): CustomerAccountInfomation {
    return {
        'id': json['id'],
        'firstName': !exists(json, 'first_name') ? undefined : json['first_name'],
        'lastName': !exists(json, 'last_name') ? undefined : json['last_name'],
        'company': !exists(json, 'company') ? undefined : json['company'],
        'email': json['email'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
        'addressLine1': !exists(json, 'address_line1') ? undefined : json['address_line1'],
        'addressLine2': !exists(json, 'address_line2') ? undefined : json['address_line2'],
        'city': !exists(json, 'city') ? undefined : json['city'],
        'region': !exists(json, 'region') ? undefined : json['region'],
        'postalCode': !exists(json, 'postal_code') ? undefined : json['postal_code'],
        'language': !exists(json, 'language') ? undefined : json['language'],
        'country': !exists(json, 'country') ? undefined : json['country'],
        'url': !exists(json, 'url') ? undefined : json['url'],
    };
}

export function CustomerAccountInfomationToJSON(value?: CustomerAccountInfomation): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'id': value.id,
        'first_name': value.firstName,
        'last_name': value.lastName,
        'company': value.company,
        'email': value.email,
        'phone': value.phone,
        'address_line1': value.addressLine1,
        'address_line2': value.addressLine2,
        'city': value.city,
        'region': value.region,
        'postal_code': value.postalCode,
        'language': value.language,
        'country': value.country,
        'url': value.url,
    };
}


